'use client';

import { Text, Translation } from '@/ui/components';
import Image from 'next/image';
import facebookPic from '@root/public/images/social-facebook.svg';
import googlePic from '@root/public/images/social-google.svg';

import s from './SocialButton.module.css';

type SocialButtonProps = {
  variant?: 'facebook' | 'google';
  onClick: () => void;
};

const SocialButton = ({ variant = 'facebook', onClick }: SocialButtonProps) => {
  return (
    <button className={s.button} onClick={onClick}>
      {variant === 'google' && (
        <>
          <Image src={googlePic} alt="Google Icon" className={s.picture} />
          <Text component="span">
            <Translation context="login" token="login_social_google" />
          </Text>
        </>
      )}
      {variant === 'facebook' && (
        <>
          <Image src={facebookPic} alt="Facebook Icon" className={s.picture} />
          <Text component="span">
            <Translation context="login" token="login_social_facebook" />
          </Text>
        </>
      )}
    </button>
  );
};

export default SocialButton;
